import { render, staticRenderFns } from "./BookingConfirmation.vue?vue&type=template&id=579379bc"
import script from "./BookingConfirmation.vue?vue&type=script&lang=js"
export * from "./BookingConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports